import { FC } from 'react';
import { StyledSummaryRow } from './SummaryRow.styled';

interface SummaryRowProps {
  label: string;
  value: string;
}

const SummaryRow: FC<SummaryRowProps> = (props) => {
  const { label, value } = props;

  return (
    <StyledSummaryRow>
      <span className="label-text">{label}</span>
      <span>{value}</span>
    </StyledSummaryRow>
  );
};

export default SummaryRow;
